import { Flex, Button } from '@chakra-ui/react';
import { useState, FC } from 'react';
import Clipboard from '../Icons/Clipboard';
export interface CbCopyToClipboardProps {
  copyText: string;
}
export const CbCopyToClipboard: FC<CbCopyToClipboardProps> = ({
  copyText
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const copyTextToClipboard = async (text: string) => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  };
  const handleCopyClick = () => {
    copyTextToClipboard(copyText).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2500);
    }).catch(err => {
      console.log(err);
    });
  };
  return <>
      <Flex borderWidth="1px" borderRadius={10} fontWeight="bold" fontSize="lg" paddingY={4} paddingX={4} justifyContent="space-between" color="text.primary" data-sentry-element="Flex" data-sentry-source-file="CbCopyToClipboard.tsx">
        {copyText}
        <Button size="xs" backgroundColor="cloud.100" _focus={{
        outline: 'none'
      }} color="text.secondary" onClick={handleCopyClick} borderRadius={50} leftIcon={<Clipboard />} data-sentry-element="Button" data-sentry-source-file="CbCopyToClipboard.tsx">
          <span>{isCopied ? 'Copied!' : 'Copy'}</span>
        </Button>
      </Flex>
    </>;
};